import SeriesHostQ from '@/queries/SeriesHostQ'
import SeriesQ from '@/queries/SeriesQ'
import type { Query } from '@/client/query'

import CohostReviewBanner from '@/components/Host/CohostReviewBanner'
import BreakoutSessionBanner from '@/components/Series/Banners/BreakoutSessionBanner/BreakoutSessionBanner'
import SeriesBannerEnrollmentStatus from '@/components/Series/Banners/SeriesBannerEnrollmentStatus'
import SeriesConsentReminderBanner from '@/components/Series/Banners/SeriesConsentReminderBanner'
import SeriesLiveBanner from '@/components/Series/Banners/SeriesLiveBanner/SeriesLiveBanner'
import SeriesReferredBanner from '@/components/Series/Banners/SeriesReferredBanner'
import SeriesReservationBanner from '@/components/Series/Banners/SeriesReservationBanner'
import SeriesUserWithdrawnBanner from '@/components/Series/Banners/SeriesUserWithdrawnBanner'
import SummerCampSeriesBanner from '@/components/SummerCamp/SummerCampSeriesBanner'

export default function SeriesHomeBanners({ series }: { series: Query }): JSX.Element {
  const pendingCohosts = series.many(
    SeriesHostQ.where({
      seriesId: SeriesQ.id,
      include: [{ association: 'User', required: true }],
      approved: false,
    })
  )

  const isSummerCampSeries =
    series != null ? (series(SeriesQ.isSummerCampSeries()) ?? false) : false

  // By convention, the rule of thumb for series banners
  // (except for the SummerCampSeriesBanner) is that
  // the decision about whether or not to show a banner
  // is made inside the banner component itself.
  return (
    <>
      <BreakoutSessionBanner series={series} />
      <SeriesLiveBanner series={series} />
      <SeriesConsentReminderBanner series={series} />
      <SeriesReservationBanner series={series} />
      <SeriesReferredBanner series={series} />
      <SeriesUserWithdrawnBanner series={series} />
      <SeriesBannerEnrollmentStatus series={series} />
      {isSummerCampSeries ? <SummerCampSeriesBanner /> : null}
      <CohostReviewBanner
        sessionOrSeries={series}
        pendingCohosts={pendingCohosts}
        isSession={false}
      />
    </>
  )
}
